import script from "./values-edit.vue?vue&type=script&setup=true&lang=js"
export * from "./values-edit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__